import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import validateFormatZipCode from 'commons/validateFormatZipCode';
import zipCodeFromUserAtom from './zipCodeFromUserAtom';
const useSetZipCodeFromUser = () => {
  const $ = _c(2);
  const setZipCodeFromUserAtom = useSetAtom(zipCodeFromUserAtom);
  let t0;
  if ($[0] !== setZipCodeFromUserAtom) {
    t0 = zipCode => {
      if (!zipCode) {
        setZipCodeFromUserAtom("");
        return;
      }
      if (validateFormatZipCode(zipCode)) {
        setZipCodeFromUserAtom(zipCode);
      }
    };
    $[0] = setZipCodeFromUserAtom;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setZipCodeFromUser = t0;
  return setZipCodeFromUser;
};
export default useSetZipCodeFromUser;